// Collapsible blocks made with the editor's "Rendre repliable" (see
// app/components/Editor/block/root/index.js). The toggle carries data-ink-collapse
// instead of Bootstrap's data-bs-toggle so that nothing toggles it inside the editor
// (a stray .show would be saved); here it is wired for visitors only.
const isEditor = ()=>typeof window.wp_inkube_data !== 'undefined';

document.addEventListener('click', (e)=>{
	// data-ink-collapse, or — if a later edit in wp-admin dropped that attribute —
	// the toggle paragraph's link to #ink-collapse-….
	const toggle = e.target && e.target.closest
		? e.target.closest('[data-ink-collapse], .ink-collapse-toggle a[href^="#ink-collapse-"]')
		: null;
	if (!toggle || isEditor()) return;
	const target = document.querySelector(toggle.getAttribute('data-ink-collapse') || toggle.getAttribute('href'));
	if (!target) return;
	e.preventDefault();
	const open = toggle.getAttribute('aria-expanded') !== 'true';
	// Bootstrap 5 (enqueued by BlogModule) animates it; without it, just show/hide.
	if (window.bootstrap && window.bootstrap.Collapse){
		window.bootstrap.Collapse.getOrCreateInstance(target, {toggle: false})[open ? 'show' : 'hide']();
	} else {
		target.classList.toggle('show', open);
	}
	toggle.setAttribute('aria-expanded', String(open));
});
